module.exports = __webpack_public_path__ + "img/icon_guanyuwomen_yinqing@3x.ffca9549.png";